
    import { defineComponent } from 'vue';
    import { Form, Field } from "vee-validate";
    import * as yup from "yup";
    import { AxiosError, AxiosResponse } from 'axios';
    import { useProgrammatic } from '@oruga-ui/oruga-next';

    const { oruga } = useProgrammatic();

    export default defineComponent({
        components: {
            Form,
            Field
        },
        directives: {
        },
        filters: {
        },
        props: {
        },
        data() {
            function toast(errorMessage: string) {
                oruga.notification.open({
                    message: `${errorMessage}`,
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 2000,
                    variant: 'success'
                });
            }

            function failureToast(errorMessage: string) {
                oruga.notification.open({
                    message: `${errorMessage}`,
                    rootClass: 'toast-notification',
                    position: 'top',
                    variant: 'danger',
                    duration: 5000,
                    closable: true
                });
            }

            return {
                toast,
                failureToast,
                Email: '',
            }
        },
        computed: {
            schema(): object {
                return yup.object().shape({
                    Email: yup
                        .string()
                        .required("Email address is required")
                        .email("Must be a valid email address")
                        .max(200, "Max allowed Charactors is 200")
                });
            }
        },
        watch: {
        },
        mounted() {
        },
        methods: {
            onSubmit() {
                this.$axios
                    .get('account/ForgotPassword', {
                        params: {
                            email: this.Email,
                        }
                    })
                    .then(({ data }: AxiosResponse<any>) => {
                        this.toast(data);
                    })
                    .catch(({ response }: AxiosError<any>) => {
                        this.failureToast(response?.data);
                    })
                    .finally(() => {
                    });
            },
        },
    });
